import { createFileRoute } from '@tanstack/react-router'

import { useDemoStore } from '~/boundedContext/demo/stores/demo'
import i18n from '~/i18n'

export const Route = createFileRoute('/demo/_layout')({
  beforeLoad: async () => {
    useDemoStore.setState({ isDemo: true })
    await i18n.loadNamespaces('demo')
  },
  onLeave: () => {
    useDemoStore.setState({ isDemo: false })
  },
})
